import React from 'react';

// Catches render-time errors anywhere below it so a single bad component/route
// shows a recoverable message instead of unmounting the whole app to a blank
// (dark) screen.
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('Render error caught by ErrorBoundary:', error, info);
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div className="min-h-screen grid place-items-center bg-[#070a12] text-center px-6">
        <div>
          <div className="font-display font-extrabold text-6xl fire-text">Oops</div>
          <h1 className="font-heading font-bold text-2xl text-white mt-4">Something went wrong</h1>
          <p className="text-gray-400 mt-2">This page hit an unexpected error. Please try again.</p>
          <div className="flex gap-3 justify-center mt-6">
            <button
              onClick={() => window.location.reload()}
              className="px-6 py-3 rounded-xl bg-gradient-to-r from-primary to-accent text-white font-heading font-bold"
            >
              Reload
            </button>
            <a
              href="/"
              className="px-6 py-3 rounded-xl bg-white/5 border border-white/15 text-white font-heading font-bold"
            >
              Back to Home
            </a>
          </div>
        </div>
      </div>
    );
  }
}
